import React from 'react';

//colors in classNames are not necessarily the html color with that name

export default function MapLegend(props) {
  const { title, footer } = props;
  return (
      <table className="mapLegend-container" summary="Legend for point value markers on map">
        <tbody>
          <tr>
            <th colSpan="10">{title}</th>
          </tr>
          <tr>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-darkred"></div></td>
            <td className="mapLegend-value-container">&ge;0 to &le;2</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-orangered"></div></td>
            <td className="mapLegend-value-container">&gt;2 to &le;10</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-gold"></div></td>
            <td className="mapLegend-value-container">&gt;10 to &le;20</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-khaki"></div></td>
            <td className="mapLegend-value-container">&gt;20 to &le;30</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-springgreen"></div></td>
            <td className="mapLegend-value-container">&gt;30 to &le;70</td>
          </tr>
          <tr>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-lightskyblue"></div></td>
            <td className="mapLegend-value-container">&gt;70 to &le;80</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-cornflowerblue"></div></td>
            <td className="mapLegend-value-container">&gt;80 to &le;90</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-teal"></div></td>
            <td className="mapLegend-value-container">&gt;90 to &le;98</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-indigo"></div></td>
            <td className="mapLegend-value-container">&gt;98 to &le;100</td>
            <td className="mapLegend-icon-container"></td>
            <td className="mapLegend-value-container"></td>
          </tr>
        </tbody>
        {footer &&
          <tfoot>
            <tr>
              <td colspan="10" style={{fontSize: "100%"}}>{footer}</td>
            </tr>
          </tfoot>
        }
      </table>
    );
}